import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  ViggoCorePageNotfoundComponent
} from 'viggo-sistemas-core-web';

import { LoggedComponent, RecoveryScreenComponent } from '@app/app-components';
import { SafeModeComponent } from '@app/app-components/recovery-screen/safe-mode.component';
import { SelectiveStrategyService } from '@app/global services';
import { AuthGuard } from 'viggo-sistemas-core-web';
import { routesAdmin } from './routes_admin/routes_admin';
import { routesSysadmin } from './routes_sysadmin/routes_sysadmin';
import { routesUnloggedUser } from './routes_unlogged';
import { routesWorkspace } from './routes_workspace';

export const routes: Routes = [
  ...routesUnloggedUser,
  {
    path: '',
    component: LoggedComponent,
    canActivate: [AuthGuard],
    children: [
      ...routesWorkspace,
      ...routesAdmin,
      ...routesSysadmin,
      // caso ele esteja na rota raiz, redireciona para o workspace
      { path: '', redirectTo: '/workspace', pathMatch: 'full' }
    ]
  },
  { path: 'recovery', component: RecoveryScreenComponent },
  { path: 'safe-mode', component: SafeModeComponent },
  {
    path: '**',
    data: {
      appName: ' ',
      logoTopBar: 'assets/images/WoundCareSys-icone.png'
    },
    component: ViggoCorePageNotfoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: SelectiveStrategyService
    })
  ],
  exports: [RouterModule],
  providers: [SelectiveStrategyService]
})
export class AppRoutingModule {}
